module.exports = __webpack_public_path__ + "static/media/web_zh.c26c5dd0.png";